module.exports = __webpack_public_path__ + "static/media/impact-empty-state.bfc69704.png";